import { Box, Grid } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import { useOrganization } from "../../store/organization";
import { BookButton } from "./BookButton";

export function StickyHeader({ lg, toggleZipModalOpen }) {
  const isMobile = useMediaQuery("(max-width:600px)");

  const { organization } = useOrganization();

  return (
    <Grid
      item={true}
      className={`tw-fixed tw-z-50 tw-w-full ${isMobile? "" : "tw-border-b"}`}
      lg={lg}
      md={12}
      sm={12}
      xs={12}
    >
      <nav
        className="skipti-nav tw-h-20 tw-p-0 tw-m-0 tw-bg-white tw-w-full"
      >
        <div
          className={`tw-h-full tw-flex tw-pr-0 tw-w-full ${isMobile ? "tw-justify-center" : "tw-justify-between"}`}
          style={{ backgroundColor: "#fff", padding: isMobile ? "20px 0 0 0" : "20px" }}
        >
          <div className="tw-pl-4 tw-pr-4 tw-h-full tw-items-center tw-flex">
            <Box>
              <Link
                className="skipti-logo d-none d-md-block p-0"
                to="/items/appointment/freetrialride"
              >
                <img
                  src={organization.data.navbarLogo}
                  alt=""
                  className="tw-h-10 tw-max-w-none"
                  style={{ zIndex: "2", width: "100px", height: "56px" }}
                />
              </Link>
            </Box>
          </div>

          {!isMobile && (
            <div className="tw-text-base tw-justify-items-center tw-self-center">
              <BookButton color="yellow" onClick={toggleZipModalOpen}/>
            </div>
          )}
        </div>
      </nav>
    </Grid>
  );
}
